import { CellContext } from "@tanstack/react-table"
import dayjs from "dayjs"
import styled from "styled-components"

import { UITypes } from "types"
import { ReactComponent as IconClock } from "assets/svg/clock.svg"

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: -10px 0;
`

const ClockIcon = styled(IconClock)`
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  path {
    stroke: #64748b;
  }
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

const DateText = styled.span`
  font-size: 14px;
  line-height: 1.5;
  font-weight: 300;
  color: #0f172a;
`

const TimeText = styled.span`
  font-size: 12px;
  line-height: 1.5;
  font-weight: 300;
  color: #64748b;
`

interface DateTimeCellProps {
  cell: CellContext<UITypes.TableBodyRow, UITypes.TableBodyCell>
}

const DateTimeCell = ({ cell: { getValue } }: DateTimeCellProps) => {
  const cellProps = getValue() as UITypes.TableBodyCell
  const dateTimeValue = cellProps.value as string | null | undefined

  if (!dateTimeValue) {
    return null
  }

  const dateTime = dayjs(dateTimeValue)
  const formattedDate = dateTime.format("L")
  const formattedTime = dateTime.format("LT")

  return (
    <Container>
      <ClockIcon />
      <Content>
        <DateText>{formattedDate}</DateText>
        <TimeText>{formattedTime}</TimeText>
      </Content>
    </Container>
  )
}

export default DateTimeCell
